module.exports = __webpack_public_path__ + "static/media/recruit-fallback.cf1267d4.png";